import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActiveModal } from '@healthcatalyst/cashmere';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';
import { WindowService } from 'src/app/modules/data/data-entry/services/window.service';
import { CashmereModule } from 'src/app/shared/cashmere.module';

@Component({
    selector: 'cdp-dbx-sign-in-modal',
    templateUrl: './dbx-sign-in-modal.component.html',
    styleUrl: './dbx-sign-in-modal.component.scss',
    imports: [CommonModule, CashmereModule]
})
export class DbxSignInModalComponent implements OnInit {
    url: string;
    loginClick = false;

    constructor(
        public activeModal: ActiveModal,
        private window: WindowService,
        private toast: ToastNotificationService
    ) {}

    ngOnInit(): void {
        this.url = this.activeModal.data.url;
    }

    dbxLogIn() {
        const dbxWindow = this.window.open(this.url, '_blank', 'width=900,height=700,resizable=yes,scrollbars=yes');

        if (!dbxWindow || dbxWindow.closed || typeof dbxWindow.closed === 'undefined') {
            this.showPopupBlockedMessage();
        } else {
            this.loginClick = true;
        }
    }

    navigateToDashboard() {
        this.activeModal.close();
    }

    cancel() {
        this.activeModal.dismiss();
    }

    private showPopupBlockedMessage() {
        this.toast.showWarning(
            'Please allow popups in your browser settings to continue with Databricks login.',
            'Popup Blocked'
        );
    }
}
